<template>
  <div class="checkout">
    <v-form @submit.prevent="guardar_datos_envio()">
      <v-container style=" min-height: calc(100vh - 350px);" class="pb-8 padding-top-secciones">
        <v-row align="center">
          <v-col cols="12">
            <v-breadcrumbs :items="items" divider="|" class="pl-3 py-3"></v-breadcrumbs>
          </v-col>
        </v-row>

        <v-row align="center" class="mb-8 d-none d-sm-flex">
          <v-spacer></v-spacer>
          <v-col class="text-center" cols="auto">
            <span class="d-inline-block titulo gris" style="width: 250px">1. SESIÓN</span>
          </v-col>
          <v-spacer>
            <hr />
          </v-spacer>
          <v-spacer>
            <hr />
          </v-spacer>
          <v-col class="text-center" cols="auto">
            <span class="d-inline-block titulo verde-oscuro" style="width: 250px">2. DATOS DE ENVIO</span>
          </v-col>
          <v-spacer>
            <hr />
          </v-spacer>
          <v-spacer>
            <hr />
          </v-spacer>
          <v-col class="text-center" cols="auto">
            <span class="d-inline-block titulo gris" style="width: 250px">3. TIPO DE PAGO</span>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <v-row class="d-sm-none" align="center">
          <v-col class="text-center" cols="auto">
            <v-avatar color="#D8D8D8">
              <span>1</span>
            </v-avatar>
          </v-col>
          <v-spacer>
            <hr />
          </v-spacer>

          <v-col cols="auto" class="text-center">
            <v-avatar color="#03241D">
              <span class="white--text">2</span>
            </v-avatar>
          </v-col>
          <v-spacer>
            <hr />
          </v-spacer>
          <v-col cols="auto" class="text-center">
            <v-avatar color="#D8D8D8">3</v-avatar>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" sm="10" md="8" lg="8" xl="5">

              <v-row align="center">
                <v-col cols="12" md="auto" class="text-center text-md-left">
                  <v-img src="@/assets/img/postales.gif" width="300px" class="mx-auto"></v-img>
                </v-col>
                <v-col cols="12" class="d-md-none">
                  <p class="modernist-bold verde-oscuro d-block mx-auto" style="max-width: 280px">
                    Con las combinaciones de regalo, entregaremos un print de nuestra fotógrafa favorita, Mar Cárdenas(c) y un mensaje personalizado. 
                    <br />
                    <br />
                    Aplican condiciones de entrega inmediata.
                  </p>
                </v-col>
                <v-col class="d-none d-md-flex">
                  <p class="modernist-bold verde-oscuro d-block mx-auto" style="max-width: 280px">
                    Con las combinaciones de regalo, entregaremos un print de nuestra fotógrafa favorita, Mar Cárdenas(c) y un mensaje personalizado. 
                    <br />
                    <br />
                    Aplican condiciones de entrega inmediata.
                  </p>
                </v-col>
              </v-row>


              <v-row class="mt-6">
                <v-col cols="12">

                  <span class="subtitulo verde-oscuro">TIEMPO DE ENTREGA</span>

                  <p class="text-font verde-oscuro mt-2">
                    Con la realización de tu pedido antes de las 2:00 pm, nos aseguramos de entregar en 24 horas y dependiendo de la ciudad en la que vivas, podrás indicarnos algunas preferencias de entrega. Después de las 2:00 pm, la entrega se realizará en 48 horas. En todos los casos, un experto de Chlorophilia será quien realice la entrega y podrá resolver tus dudas al rededor de la correcta ubicación y cuidado de tu nueva green roomie.
                  </p>
                </v-col>
              </v-row>

          </v-col>
        </v-row>

        <transition name="fade-transition" mode="out-in">
          <div class="animated fadeIn">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row justify="center">
                <v-col cols="12" sm="10" md="8" lg="8" xl="5">
                  <div>
                    <v-row>
                      <v-col>
                        <span class="subtitulo verde-oscuro">DATOS DE CONTACTO</span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          type="email"
                          v-model="personal.email"
                          label="EMAIL"
                          color="#979797"
                          :disabled="this.$session.has('user')"
                          :rules="emailRules"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="!this.$session.has('user')">
                      <v-col class="py-0">
                        <v-text-field
                          type="email"
                          v-model="personal.confirmacion"
                          label="CONFIRMACIÓN DE EMAIL"
                          color="#979797"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          v-model="personal.nombre"
                          label="NOMBRE Y APELLIDOS"
                          color="#979797"
                          :rules="nameRules"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          v-model="personal.telefono"
                          label="TELÉFONO MÓVIL"
                          color="#979797"
                          :rules="phoneRules"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <span class="subtitulo verde-oscuro">ETIQUETA DE REGALO</span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" class="py-0">
                        <v-text-field v-model="personal.de" label="DE" color="#979797"></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field v-model="personal.para" label="PARA" color="#979797"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="py-0">
                        <v-textarea v-model="personal.mensaje" label="ESCRIBE UN MENSAJE" color="#979797" counter="200"></v-textarea>
                      </v-col>
                    </v-row>
                  </div>

                  <v-row>
                    <v-col>
                      <span class="subtitulo verde-oscuro">DATOS DE ENVÍO</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="8" class="py-0">
                      <v-text-field
                        v-model="envio.direccion"
                        label="Calle"
                        color="#979797"
                        :rules="direccionRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="2" class="py-0">
                      <v-text-field
                        v-model="envio.numero"
                        label="No ext."
                        color="#979797"
                        :rules="numeroRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="2" class="py-0">
                      <v-text-field v-model="envio.numero_interno" label="No int." color="#979797"></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- 
                                <v-row>
                                    <v-col class="py-0">
                                        <v-text-field v-model="envio.direccion_extra" label="Más información (opcional)"
                                            color="#979797">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                  -->

                  <v-row>
                    <v-col cols="6" class="py-0">
                      <v-text-field v-model="envio.referencia" label="Referencia" color="#979797"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-text-field
                        v-model="envio.colonia"
                        label="Colonia"
                        color="#979797"
                        :rules="coloniaRules"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" class="py-0">
                      <template v-if="envio.estado == 'Coahuila'">
                        <v-select
                          :items="ciudades_coahuila"
                          label="Ciudad o Municipio"
                          color="#979797"
                          :rules="municipioRules"
                        ></v-select>
                      </template>
                      <template v-else>
                        <v-text-field
                          v-model="envio.municipio"
                          label="Ciudad o Municipio"
                          color="#979797"
                          :rules="municipioRules"
                        ></v-text-field>
                      </template>
                      <!-- <v-text-field
                        v-model="envio.municipio"
                        label="Ciudad o Municipio"
                        color="#979797"
                        :rules="municipioRules"
                      ></v-text-field> -->
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-text-field
                        v-model="envio.codigo_postal"
                        label="Código Postal"
                        color="#979797"
                        :rules="codigoPostalRules"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="6" class="py-0">
                                        <v-text-field v-model="envio.ciudad" label="Ciudad" color="#979797"></v-text-field>
                    < /v-col>-->
                  </v-row>

                  <v-row>
                    <v-col cols="6" class="py-0">
                      <v-select
                        :items="estados"
                        label="Estado"
                        color="#979797"
                        v-model="envio.estado"
                      ></v-select>
                      <!-- <v-text-field
                        v-model="envio.estado"
                        label="Estado"
                        color="#979797"
                        :disabled="true"
                      ></v-text-field> -->
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-text-field
                        v-model="envio.pais"
                        label="País"
                        color="#979797"
                        disabled
                        value="México"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="envio.preferencia_entrega"
                        :items="preferencia_horario"
                        label="Preferencia de Entrega"
                        color="#064434"
                        item-color="#064434"
                        :rules="preferenciaHorarioRules"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="py-0">
                      <v-switch
                        v-model="personal.factura"
                        class="ma-2"
                        label="¿Necesitas factura?"
                        color="#064434"
                      ></v-switch>
                    </v-col>

                    <v-col class="py-0" v-if="personal.factura">
                      <v-switch
                        v-model="mismos_datos"
                        class="ma-2"
                        label="¿Usar dirección de envío?"
                        color="#064434"
                      ></v-switch>
                    </v-col>
                  </v-row>

                  <div v-if="personal.factura">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.rfc"
                          class="ma-2"
                          label="RFC"
                          color="#064434"
                          :rules="rfcRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.razon_social"
                          class="ma-2"
                          label="Razón Social"
                          color="#064434"
                          :rules="razonSocialRules"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" sm="8">
                        <v-text-field
                          v-model="factura.calle"
                          class="ma-2"
                          label="Calle"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="2">
                        <v-text-field
                          v-model="factura.numero"
                          class="ma-2"
                          label="No Ext."
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="2">
                        <v-text-field
                          v-model="factura.numero_interno"
                          class="ma-2"
                          label="No Int."
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.colonia"
                          class="ma-2"
                          label="Colonia"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.municipio"
                          class="ma-2"
                          label="Ciudad o Municipio"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="6">
                                            <v-text-field v-model="factura.municipio" class="ma-2" label="Municipio" color="#064434"></v-text-field>
                      </v-col>-->
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.codigo_postal"
                          class="ma-2"
                          label="Código Postal"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.estado"
                          class="ma-2"
                          label="Estado"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="factura.pais"
                          class="ma-2"
                          label="País"
                          color="#064434"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="factura.cfdi"
                          :items="cfdi"
                          label="Uso de CFDI"
                          color="#064434"
                          item-color="#064434"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </transition>
      </v-container>

      <v-container fluid class="py-0">
        <v-row>
          <v-col class="py-0 px-0">
            <!-- <router-link to="/enviar"> -->
            <v-btn tile color="#064434" block height="40" type="submit">
              <span class="blanco modernist-bold">Continuar</span>
            </v-btn>
            <!-- </router-link> -->
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import VueSession from "vue-session";

Vue.use(VueSession, {
  persist: true
});
export default {
  data: () => ({
    items: [
      {
        text: "Inicio",
        disabled: false,
        to: "/"
      },
      {
        text: "Cesta de Compra",
        disabled: false,
        to: "/cart"
      },
      {
        text: "Tramitar pedido",
        disabled: true
      },
      {
        text: "2. Datos de Envío",
        disabled: true
      }
    ],
    estados: ['Nuevo León', 'Coahuila'],
    ciudades_coahuila: ['Ramos Arizpe','Saltillo'],
    paso: 1, // Paso general (1 -> Sesión, 2 -> Datos de envio, 3 -> Tipo de pago)
    paso_sesion: 0, // Paso referente a la sesión (0 -> sin seleccion, 1 -> iniciar sesión, 2 -> registrate),
    login: {
      email: "",
      password: ""
    },
    personal: {
      email: "",
      confirmacion: "",
      nombre: "",
      telefono: "",
      factura: false,
      mensaje: ""
    },
    mismos_datos: false,
    envio: {
      direccion: "",
      numero: "",
      numero_interno: "",
      referencia: "",
      colonia: "",
      ciudad: "",
      municipio: "",
      codigo_postal: "",
      estado: "Nuevo León",
      direccion_extra: "",
      pais: "México",
      preferencia_entrega: ''
    },
    factura: {
      rfc: "",
      razon_social: "",
      calle: "",
      numero: "",
      numero_interno: "",
      colonia: "",
      ciudad: "",
      municipio: "",
      codigo_postal: "",
      estado: "",
      pais: "",
      cfdi: ""
    },
    preferencia_horario: ["Por la mañana", "Por la tarde"],
    cfdi: ["1. Gastos en General", "2. Mercancía"],
    valid: false,
    emailRules: [
      v => !!v || "* Requerido",
      v =>
        /.+@.+\..+/.test(v) ||
        "Debes ingresar una dirección correo electrónico válido"
    ],
    nameRules: [v => !!v || "* Requerido"],
    phoneRules: [v => !!v || "* Requerido"],
    direccionRules: [v => !!v || "* Requerido"],
    numeroRules: [v => !!v || "* Requerido"],
    numeroInternoRules: [v => !!v || "* Requerido"],
    coloniaRules: [v => !!v || "* Requerido"],
    municipioRules: [v => !!v || "* Requerido"],
    codigoPostalRules: [
      v => !!v || "* Requerido",
      v => /^\d*$/.test(v) || 'Debe ser número',
      v => (v && v.length == 5) || 'El código postal debe ser un número de 5 dígitos',
    ],
    preferenciaHorarioRules: [v => !!v || "* Requerido"],
    rfcRules: [v => !!v || "* Requerido"],
    razonSocialRules: [v => !!v || "* Requerido"]
  }),
  methods: {
    login_fnc: function() {
      axios
        .post("http://192.168.15.100:1337/auth/local", {
          identifier: this.login.email,
          password: this.login.password
        })
        .then(response => {
          // Handle success.
          console.log("Well done!");
          // console.log('User profile', response.data.user);
          // console.log('User token', response.data.jwt);
          console.log(response.data);
          this.$session.set("user", response.data);
          this.paso = 2;
        })
        .catch(error => {
          // Handle error.
          console.log("An error occurred:", error);
        });
    },
    guardar_datos_envio: function() {
      if (this.$refs.form.validate()) {
        this.$session.set("envio", this.envio);
        this.$session.set("factura", this.factura);
        this.$session.set("personal", this.personal);
        this.$router.push("/CheckoutRegalo/metodo-pago");
      }
    }
  },
  created: function() {
    if (this.$session.has("user")) {
      this.personal.email = this.$session.get("user").user.email;
    }

    let city_selected = this.$session.get('ciudad_seleccionada');

    if(city_selected == 'Monterrey'){
      this.estados = ['Nuevo León'];
      this.envio.estado = 'Nuevo León';
    }else if(city_selected == 'Saltillo'){
      this.estados = ['Coahuila'];
      this.envio.estado = 'Coahuila';
    }else if(city_selected == 'Querétaro'){
      this.estados = ['Querétaro'];
      this.envio.estado = 'Querétaro';
    }
    

  },
  watch: {
    mismos_datos: function() {
      if (this.mismos_datos) {
        this.factura.calle = this.envio.direccion;
        this.factura.numero = this.envio.numero;
        this.factura.numero_interno = this.envio.numero_interno;
        this.factura.colonia = this.envio.colonia;
        this.factura.ciudad = this.envio.ciudad;
        this.factura.municipio = this.envio.municipio;
        this.factura.estado = this.envio.estado;
        this.factura.codigo_postal = this.envio.codigo_postal;
      }
    }
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Datos de Envío para Checkout de Regalo',
      'page_path': '/CheckoutRegalo/envio'
    });
  }
};
</script>